module.exports = __webpack_public_path__ + "img/blog-2.15c44625.webp";